// extracted by mini-css-extract-plugin
export default {"reviews":"Reviews_reviews__MePhA","review":"Reviews_review__p9pRy","reviewDate":"Reviews_reviewDate__qTyRx","mobile":"Reviews_mobile__AkhS+"};